export const constants = {
  // serverURL : "https://ms-education-server.onrender.com", //development
  serverURL: "https://server.maheshsuchit.com", //production
  // serverURL: "http://localhost:3000", //local
};
